import { FullPageLoader } from 'components/Loader/Loader';
import { authorizeUser } from 'modules/auth/authSlice';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { RootState } from 'store';
import { parseEnteprisesWithSignPolicy } from 'utils/sign-policy';

const UserBootstrapper: FC = ({ children }) => {
  const { loading: authLoading, ready } = useSelector((state: RootState) => state.auth);
  const { loading: userLoading, accounts } = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();

  // eslint-disable-next-line no-undef
  const ENTERPRISE_POLICIES = process.env.REACT_APP_ENTERPRISE_OPTIONS ?? '';
  const availableEnterprises = parseEnteprisesWithSignPolicy(ENTERPRISE_POLICIES);
  const currentDomain = location.pathname.replace(/^\/|\/$/g, '');

  useEffect(() => {
    if (ready) {
      dispatch(authorizeUser());
    }
  }, [ready]);

  if (authLoading || (userLoading && !accounts)) {
    return <FullPageLoader />;
  }
  // this redirect is for "after login" as msal is redirecting to the previous
  // url, in that case https://portal.chooose.today/<domain>
  // so after successful login just redirect to root
  if (availableEnterprises.get(currentDomain)) {
    return <Redirect to="/" />;
  }
  return <>{children}</>;
};

export default UserBootstrapper;
